/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When is the Wallace rule good enough?`)
};

const es_tm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuándo es suficiente la regla de Wallace?`)
};

const de_tm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann reicht die Wallace-Regel aus?`)
};

const nl_tm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wanneer volstaat de Wallace-regel?`)
};

const fr_tm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand la règle de Wallace suffit-elle ?`)
};

const it_tm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando la regola di Wallace è sufficiente?`)
};

const pt_br2_tm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando a regra de Wallace é suficiente?`)
};

const pt_tm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando é que a regra de Wallace é suficiente?`)
};

const ja_tm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wallace法で十分な場合はいつですか？`)
};

const zh_tm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么时候 Wallace 规则就足够了？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_faq_q3", locale)
	if (locale === "en") return en_tm_faq_q3(inputs)
	if (locale === "es") return es_tm_faq_q3(inputs)
	if (locale === "de") return de_tm_faq_q3(inputs)
	if (locale === "nl") return nl_tm_faq_q3(inputs)
	if (locale === "fr") return fr_tm_faq_q3(inputs)
	if (locale === "it") return it_tm_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_tm_faq_q3(inputs)
	if (locale === "pt") return pt_tm_faq_q3(inputs)
	if (locale === "ja") return ja_tm_faq_q3(inputs)
	return zh_tm_faq_q3(inputs)
};